import { render, staticRenderFns } from "./BlogDetailsPost.vue?vue&type=template&id=62a44f48&"
import script from "./BlogDetailsPost.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports